module.exports = __webpack_public_path__ + "static/media/cdrs.c7041cf4.svg";